import React, { useEffect } from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Drawer from "@material-ui/core/Drawer";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import ProfitabilityReport from "../components/pages/main/inventory/ProfitabilityReport";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import LoginComponent from "../components/pages/onboarding/login/LoginPageComponent";
import Checkout from "../components/pages/main/checkout/checkout.component";
import OnBoardingLayout from "../components/pages/onboarding/onboarding-layout/OnBoardingLayout";
import AddCompanyComponent from "../components/pages/onboarding/company/AddCompanyComponent";
import ProductCategory from "../components/pages/main/product-category/ProductCategory";
import ProtectedRoute from "../router/ProtectedRoute";
import "bootstrap/dist/css/bootstrap.min.css";
import Employees from "../components/pages/main/employee/Employees";
import Product from "../components/pages/main/product/Product";
import Locations from "../components/pages/main/location/Location";
import PickUpStation from "../components/pages/main/pickupstation/PickUpStation";
import OrderDelivery from "../components/pages/main/order-delivery/OrderDelivery";
import Dashboard from "../components/pages/main/dashboard/dashboard";
import Inventory from "../components/pages/main/inventory/Inventory";
import { IncomingInventory } from "../components/pages/main/inventory/IncomingInventory";
import OutgoingInventory from "../components/pages/main/inventory/OutgoingInventory";
import InventoryCount from "../components/pages/main/inventory/InventoryCount";
import WareHouseTransfer from "../components/pages/main/inventory/WareHouseTransfer";
import InventoryReports from "../components/pages/main/inventory/InventoryReports";
import Sales from "../components/pages/main/sales/Sales";
import NewOrder from "../components/pages/main/sales/orders/NewOrder";
import Payment from "../components/pages/main/payment/Payment";
import Account from "../components/pages/main/account/Accounts";
import InventoryValuation from "../components/pages/main/inventory/InventoryValuation";
import CustomerInfo from "../components/pages/main/inventories/CustomerInfo";
import SalesReport from "../components/pages/main/inventory/SalesReport";
import InventoryManager from "../components/pages/main/dashboard/InventoryManager";
import SalesExecutive from "../components/pages/main/dashboard/SalesExecutive";
import Admin from "../components/pages/main/dashboard/Admin";
import AllocateLocation from "../components/pages/main/employee/AllocateLocation";
import Refunds from "../components/pages/main/inventories/refunds/Refunds";
import AppMenu from "../components/pages/main/main-layout/AppMenu";
import HeaderComponent from "../components/pages/header/HeaderComponent";
import Repayments from "../components/pages/main/payment/Repayments";
import CreditPayment from "../components/pages/main/payment/CreditPayment";
import PaymentHistory from "../components/pages/main/paymentHistory/PaymentHistory";
import UnfulfilledOrders from "../components/pages/AllOrders/UnfulfilledOrders";
import FulfilledOrders from "../components/pages/AllOrders/FulfilledOrders";
import Logistics from "../components/pages/main/logistics/Logistics";
import TruckTypes from "../components/pages/main/truck/truckType/TruckTypes";
import StorageTank from "../components/pages/main/storage-tanks/StorageTank";
import ProductSalesPrice from "../components/pages/main/product-price/ProductSalesPrice";
import SupplyManagement from "../components/pages/main/supplier/SupplyManagement";

const PageDashboard = () => (
  <Typography variant="h3" component="h1">
    Dashboard Page
  </Typography>
);
const PageOrders = () => (
  <Typography variant="h3" component="h1">
    Orders Page
  </Typography>
);
const PageCustomers = () => (
  <Typography variant="h3" component="h1">
    Customers Page
  </Typography>
);
const PageReports = () => (
  <Typography variant="h3" component="h1">
    Reports Page
  </Typography>
);

const NewMainLayOut = ({ cacNumber, isAuthenticated, isHaveCompany }) => {
  const classes = useStyles();
  useEffect(() => {
    if (cacNumber !== null) {
      if (cacNumber !== undefined) {
        isAuthenticated = true;
        if (cacNumber === "00000") {
          isHaveCompany = false;
        }
      }
    }
    return () => {};
  }, []);
  if (!isAuthenticated) {
    return <Redirect to={{ pathname: "/user/login" }} />;
  }
  if (!isHaveCompany) {
    return <Redirect to={{ pathname: "/add-company" }} />;
  }

  return (
    <BrowserRouter>
      <div className={clsx("App", classes.root)}>
        <CssBaseline />
        <Drawer
          variant="permanent"
          classes={{
            paper: classes.drawerPaper,
          }}
        >
          <AppMenu />
        </Drawer>
        <main className={classes.content}>
          <HeaderComponent />
          <Container
            style={{ overflowX: "hidden" }}
            maxWidth="lg"
            className={classes.container}
          >
            <Switch>
              <Route
                isAuthenticated={isAuthenticated}
                isHaveCompany={isHaveCompany}
                path="/main/outgoing"
                exact
                component={OutgoingInventory}
              />

              <Route
                isAuthenticated={isAuthenticated}
                isHaveCompany={isHaveCompany}
                path="/main/sales-report"
                exact
                component={SalesReport}
              />
              <Route
                isAuthenticated={isAuthenticated}
                isHaveCompany={isHaveCompany}
                path="/main/transfer"
                exact
                component={WareHouseTransfer}
              />
              <Route
                isAuthenticated={isAuthenticated}
                isHaveCompany={isHaveCompany}
                path="/main/reports"
                exact
                component={InventoryReports}
              />
              <Route
                isAuthenticated={isAuthenticated}
                isHaveCompany={isHaveCompany}
                path="/home"
                exact
                component={Dashboard}
              />
              <Route
                path="/reports"
                exact
                component={ProfitabilityReport}
                isHaveCompany={isHaveCompany}
              />
              <Route
                isHaveCompany={isHaveCompany}
                path="/main/count"
                exact
                component={InventoryCount}
              />
              <Route
                isAuthenticated={isAuthenticated}
                isHaveCompany={isHaveCompany}
                path="/main/incoming"
                exact
                component={IncomingInventory}
              />
              <Route
                exact
                path="/"
                render={() =>
                  isAuthenticated ? (
                    <Redirect to="/user/login" />
                  ) : (
                    <LoginComponent />
                  )
                }
              />

              <Route path="/user" component={OnBoardingLayout} />

              <ProtectedRoute
                isAuthenticated={isAuthenticated}
                path="/add-company"
                component={AddCompanyComponent}
                exact
              />
              <ProtectedRoute
                isAuthenticated={isAuthenticated}
                path="/company/credit/payment"
                component={CreditPayment}
                exact
              />

              <Route
                isAuthenticated={isAuthenticated}
                isHaveCompany={isHaveCompany}
                path="/payments"
                component={Payment}
                exact
              />
              {/* All Orders Routes */}
              <Route
                isAuthenticated={isAuthenticated}
                isHaveCompany={isHaveCompany}
                path="/FulfilledOrders"
                component={FulfilledOrders}
                exact
              />
              <Route
                isAuthenticated={isAuthenticated}
                isHaveCompany={isHaveCompany}
                path="/UnfulfilledOrders"
                component={UnfulfilledOrders}
                exact
              />
              {/* End All Orders Route */}
              <Route
                isAuthenticated={isAuthenticated}
                isHaveCompany={isHaveCompany}
                path="/payment/history"
                component={PaymentHistory}
                exact
              />
              <Route
                isAuthenticated={isAuthenticated}
                isHaveCompany={isHaveCompany}
                path="/repayments"
                component={Repayments}
                exact
              />
              <Route
                isAuthenticated={isAuthenticated}
                isHaveCompany={isHaveCompany}
                path="/valuation"
                component={InventoryValuation}
                exact
              />

              <Route
                isAuthenticated={isAuthenticated}
                isHaveCompany={isHaveCompany}
                path="/sales/customer"
                exact
                component={CustomerInfo}
              />
              <Route
                isAuthenticated={isAuthenticated}
                isHaveCompany={isHaveCompany}
                path="/inventory/report"
                exact
                component={ProfitabilityReport}
              />

              <Route
                isAuthenticated={isAuthenticated}
                isHaveCompany={isHaveCompany}
                path="/main/dashboard"
                exact
                component={Employees}
              />
              <Route
                isAuthenticated={isAuthenticated}
                isHaveCompany={isHaveCompany}
                path="/main/allocate"
                exact
                component={AllocateLocation}
              />
              <Route
                isAuthenticated={isAuthenticated}
                isHaveCompany={isHaveCompany}
                path="/main/logistics"
                exact
                component={Logistics}
              />
              <Route
                isAuthenticated={isAuthenticated}
                isHaveCompany={isHaveCompany}
                path="/main/truck/truckType"
                exact
                component={TruckTypes}
              />
              <Route
                isAuthenticated={isAuthenticated}
                isHaveCompany={isHaveCompany}
                path="/main/storage-tanks"
                exact
                component={StorageTank}
              />
              <Route
                isAuthenticated={isAuthenticated}
                isHaveCompany={isHaveCompany}
                path="/main/inventory/dashboard"
                exact
                component={InventoryManager}
              />
              <Route
                isAuthenticated={isAuthenticated}
                isHaveCompany={isHaveCompany}
                path="/main/sales/dashboard"
                exact
                component={SalesExecutive}
              />
              <Route
                isAuthenticated={isAuthenticated}
                isHaveCompany={isHaveCompany}
                path="/main/admin/dashboard"
                exact
                component={Admin}
              />
              <Route
                isAuthenticated={isAuthenticated}
                isHaveCompany={isHaveCompany}
                path="/main/product-category"
                exact
                component={ProductCategory}
              />
              <Route
                isAuthenticated={isAuthenticated}
                isHaveCompany={isHaveCompany}
                path="/checkout"
                exact
                component={Checkout}
              />
              <Route
                isAuthenticated={isAuthenticated}
                isHaveCompany={isHaveCompany}
                path="/main/product"
                exact
                component={Product}
              />
              <Route
                isAuthenticated={isAuthenticated}
                isHaveCompany={isHaveCompany}
                path="/main/product-price"
                exact
                component={ProductSalesPrice}
              />
              {/* Supplier Management Here */}
              <Route
                isAuthenticated={isAuthenticated}
                isHaveCompany={isHaveCompany}
                path="/main/supplier"
                exact
                component={SupplyManagement}
              />
              {/* End Supplier Management Here */}
              <Route
                isAuthenticated={isAuthenticated}
                isHaveCompany={isHaveCompany}
                path="/main/account"
                exact
                component={Account}
              />
              <Route
                isAuthenticated={isAuthenticated}
                isHaveCompany={isHaveCompany}
                path="/main/sales"
                exact
                component={Sales}
              />
              <Route
                isAuthenticated={isAuthenticated}
                isHaveCompany={isHaveCompany}
                path="/orders"
                exact
                component={NewOrder}
              />
              <Route
                isAuthenticated={isAuthenticated}
                isHaveCompany={isHaveCompany}
                path="/refunds"
                exact
                component={Refunds}
              />
              <Route
                isAuthenticated={isAuthenticated}
                isHaveCompany={isHaveCompany}
                path="/main/locations"
                exact
                component={Locations}
              />
              <Route
                isAuthenticated={isAuthenticated}
                isHaveCompany={isHaveCompany}
                path="/main/pickupstation"
                exact
                component={PickUpStation}
              />
              <Route
                isAuthenticated={isAuthenticated}
                isHaveCompany={isHaveCompany}
                path="/main/orderdelivery"
                exact
                component={OrderDelivery}
              />
              <Route
                isAuthenticated={isAuthenticated}
                isHaveCompany={isHaveCompany}
                path="/main/inventory"
                exact
                component={Inventory}
              />
            </Switch>
          </Container>
        </main>
      </div>
    </BrowserRouter>
  );
};

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  drawerPaper: {
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    background: "#141b28",
    color: "#fff",
  },
  content: {
    flexGrow: 1,
    height: "100vh",
    overflow: "auto",
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
}));

export default NewMainLayOut;
